import { Breadcrumb, Skeleton, Row, Col } from 'antd';
import { ButtonAction, Card, Form, FormItem, GetValidateFields, Input, Confirm, Button, generateSlugify } from 'asumsi-components';
import { LayoutCMS } from 'components';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useAction from '@pages/statics/hooks/useAction';
import SunEditor from 'suneditor-react';

export const PageStaticsFormComponent = (props: any) => {
    // set header page
    const title = 'Static Page'
    const layoutCMSProps = {
        breadcrumb: (
            <>
                <Breadcrumb.Item>
                    {title}
                </Breadcrumb.Item>
            </>
        ),
        documentTitle: title,
        history: props.history,
        pageTitle: title,
    };

    // declare action and attribute needed
    const { isLoader, getDetail, postData, updateData, detail } = useAction();
    const { match } = props;
    const idData = match.params.id;

    // initiate form data
    const initialFieldsValues: any = {
        title: null,
        slug: null,
        desc: null,
        content: null
    };

    const [fieldsValues, setFieldsValues]: any = useState(initialFieldsValues);
    const [showConfirmation, setShowConfirm] = useState(false);
    const [paramSubmit, setParamSubmit] = useState({});
    const [content, setContent] = useState();

    // first load
    useEffect(() => {
        if (idData && !detail) {
            getDetail(idData);
        }
        if (idData && detail) {
            setDefault();
        }
    }, [detail])

    // fetch data
    const setDefault = async () => {
        if (detail) {
            setFieldsValues({
                title: detail.title,
                slug: detail.slug,
                content: detail.content,
                desc: detail.desc
            });
        }
    }

    // handle submit form
    const handleSubmit = (e: any) => {
        let fieldsVal: any = fieldsValues;
        fieldsVal = { ...fieldsVal, content };
        const validateFields = GetValidateFields(fieldsVal);
        const { err, values } = validateFields;
        e.preventDefault();
        if (!err) {
            setParamSubmit(values);
            setShowConfirm(true);
        }
    };

    const onChangeContent = (value: any) => {
        setContent(value)
    }

    const onChangeSlug = (e: any) => {
        const val: string = e.target.value;
        const slug = generateSlugify(val);
        const errors = fieldsValues.errors;
        if (errors) {
            const index = errors.findIndex((element: string) => element == 'slug');
            if (index >= 0) {
                errors.splice(index, 1);
            }
        }

        if (!slug) {
            errors.push('slug');
        }
        
        setFieldsValues({ ...fieldsValues, errors, slug });
    }

    // return JSX Element 
    return (
        <LayoutCMS {...layoutCMSProps}>
            <Card className="asumsi-card-form-shadow-rd-15">
                <Form>
                    <Skeleton loading={isLoader}>
                        <Row gutter={30}>
                            <Col lg={{ span: 24 }} md={{ span: 24 }} xs={{ span: 32 }}>
                                <Row>
                                    <Col span={24}>
                                        <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Title" labelAlign="left"
                                            fieldDecorator={{
                                                label: "title",
                                                rules: [{
                                                    message: 'Please input title',
                                                    required: true,
                                                }
                                                ]
                                            }}
                                        >
                                            <Input id="title" defaultValue={fieldsValues.title} onChange={onChangeSlug} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Page URL" labelAlign="left"
                                            fieldDecorator={{
                                                label: "slug",
                                                rules: [{
                                                    message: 'Please input page url',
                                                    required: true,
                                                },
                                                {
                                                    message: "Only alphanumeric and -",
                                                    pattern: /^[a-zA-Z0-9-]+$/,
                                                }]
                                            }}
                                        >
                                            <Input id="slug" defaultValue={fieldsValues.slug} />
                                        </FormItem>
                                        <div className="result-slug-url">asumsi.co/{fieldsValues.slug}</div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Description" labelAlign="left"
                                            fieldDecorator={{
                                                label: "desc"
                                            }}
                                        >
                                            <Input id="desc" defaultValue={fieldsValues.desc} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Content" labelAlign="left"
                                            fieldDecorator={{
                                                label: "content"
                                            }}
                                        >
                                            <SunEditor setContents={fieldsValues.content} onChange={onChangeContent} height="280px" enableToolbar={true} setOptions={{
                                                resizingBar: false,
                                                mode: "classic",
                                                font: ['Arial', 'Comic Sans MS', 'Courier New', 'Georgia', 'IBM Plex Serif', 'Impact', 'Inter', 'tahoma', 'Trebuchet MS', 'Verdana'],
                                                katex: "window.katex",
                                                imageGalleryUrl: "https://etyswjpn79.execute-api.ap-northeast-1.amazonaws.com/suneditor-demo",
                                                buttonList: [
                                                    [
                                                        "undo",
                                                        "redo",
                                                        "font",
                                                        "fontSize",
                                                        "formatBlock",
                                                        "paragraphStyle",
                                                        "blockquote",
                                                        "bold",
                                                        "underline",
                                                        "italic",
                                                        "strike",
                                                        "subscript",
                                                        "superscript",
                                                        "fontColor",
                                                        "hiliteColor",
                                                        "textStyle",
                                                        "removeFormat",
                                                        "outdent",
                                                        "indent",
                                                        "align",
                                                        "horizontalRule",
                                                        "list",
                                                        "lineHeight",
                                                        "table",
                                                        "link",
                                                        "image",
                                                        "video",
                                                        "audio",
                                                        "math",
                                                        "imageGallery",
                                                        "fullScreen",
                                                        "showBlocks",
                                                        "codeView",
                                                        "preview",
                                                        "print",
                                                        "save"
                                                    ]
                                                ],
                                            }} />
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Skeleton>
                    <ButtonAction
                        left={
                            <Link to="/settings/statics">
                                <Button type="outline-red" size="medium" disabled={isLoader} text="Cancel"></Button>
                            </Link>
                        }
                        right={
                            <Button type="green" size="medium" disabled={fieldsValues.errors && fieldsValues.errors.length > 0} loading={isLoader} onClick={handleSubmit}>
                                Save
                            </Button>
                        }
                    />
                </Form>
            </Card>
            <Confirm
                key="confirm-save"
                show={showConfirmation}
                setShow={setShowConfirm}
                onOk={async () => {
                    if (!idData) {
                        // do post data
                        postData(paramSubmit);
                    } else {
                        // do update data
                        updateData(paramSubmit, idData);
                    }
                }}
                content='Apakah Anda yakin untuk menyimpan data ini?'
                title='Konfirmasi'
                okText='Ya'
                cancelText='Tidak'
            />
        </LayoutCMS>
    );
};
export default PageStaticsFormComponent;



// WEBPACK FOOTER //
// ./src/pages/statics-form/component.tsx